<section [class.button]="displayButton()" [class.disabled]="isDisabled()">
  <div class="title--container">
    <span class="subtitle2">{{ channel().channelName }}</span>
    @if (displayButton()) {
      <app-mat-icon-button
        iconName="close"
        ariaLabel="delete"
        buttonStyle="warn"
        (buttonClicked)="clickButton(channel().memorySlot)"
        [disabled]="isDisabled()"
      ></app-mat-icon-button>
    }
  </div>
  <div class="row">
    <span class="body1 title">Lower band (nm): </span>
    <span class="body1 data">{{ channel().lowerBand }}</span>
  </div>
  <div class="row">
    <span class="body1 title">Upper band (nm): </span>
    <span class="body1 data">{{ channel().upperBand }}</span>
  </div>
  <div class="row">
    <span class="body1 title">LED: </span>
    <span class="body1 data">{{ channel().led }}</span>
  </div>
</section>
